import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Form, Button, Row, Col, Modal, Table, InputGroup, Spinner } from 'react-bootstrap';
import { useParams, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import { RxCross1 } from "react-icons/rx";
import { HiPlusCircle } from "react-icons/hi";
import HelpTooltip from '../common/HelpTooltip';
import { FiBarChart2, FiCalendar, FiCheck, FiPlus } from "react-icons/fi";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Utils, authHeaders, fetchWithAuth, subscriptionStatusCodes, formatDateTime, can, findOptionByValue, MESSAGE_AUDIENCE_OPTIONS, combineLocalDateTime, toLocalIsoDate, toLocalIsoTime, parseLocalIsoDate } from '../../utils';
import DateTimePicker from '../common/DateTimePicker/DateTimePicker';
import PushNotificationPreview from './PushNotificationPreview';
const PushNotification = () => {
    const [priority, setPriority] = useState('High');
    const [actionIndex, setActionIndex] = useState(1);
    const [timeToLive, setTimeToLive] = useState(3);
    const [timeUnit, setTimeUnit] = useState('days');
    const [keyValuePairs, setKeyValuePairs] = useState([{ key: '', value: '' }]);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [displaymessage, setdisplayMessage] = useState('Default message');
    const [image, setImage] = useState(null); // local preview (blob) while uploading
    const [largeIcon, setLargeIcon] = useState('');
    const [smallIcon, setSmallIcon] = useState('');
    const [loader, setLoader] = useState(false);
    const [sendingToAll, setSendingToAll] = useState(false);
    const [sound, setSound] = useState('');
    const [lockscreenVisibility, setLockscreenVisibility] = useState('Public');
    const [appData, setAppData] = useState({})
    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState('test'); // 'test' | 'schedule'
    const [formData, setFormData] = useState(null);
    const [imageUrl, setImageUrl] = useState('');
    const [isValidImageUrl, setIsValidImageUrl] = useState(false);
    const [isImageUploading, setIsImageUploading] = useState(false);
    const [uploadedImagePath, setUploadedImagePath] = useState('');
    const [imageUrlLoadError, setImageUrlLoadError] = useState(false);
    const [actionButtons, setActionButtons] = useState([{ id: '', label: '', iconPath: '', isSystemIcon: false }]);
    const [appUsers, setAppUsers] = useState([])
    const [notificationChannelsList, setNotificationChannelsList] = useState([]);
    const [selectedChannelId, setSelectedChannelId] = useState('');

    const imageFileInputRef = useRef(null);

    // Audience section states
    const [audienceType, setAudienceType] = useState('subscribed'); // 'subscribed' or 'segment'
    const [segments, setSegments] = useState([]);
    const [selectedSegments, setSelectedSegments] = useState([]);
    const [showSegmentModal, setShowSegmentModal] = useState(false);
    const [segmentSearchTerm, setSegmentSearchTerm] = useState('');
    const [segmentCounts, setSegmentCounts] = useState({}); // runtime subscriber counts for modal

    // Scheduling states
    const [deliveryType, setDeliveryType] = useState('immediately'); // 'immediately' or 'scheduled'
    const [scheduledDate, setScheduledDate] = useState('');
    const [scheduledTime, setScheduledTime] = useState('');
    const [messageName, setMessageName] = useState('');
    const [useBestSendTime, setUseBestSendTime] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});

    // Edit mode state
    const [isEditMode, setIsEditMode] = useState(false);
    const [editMessageId, setEditMessageId] = useState(null);

    const handleClose = () => setShowModal(false);
    // const handleShow = () => setShowModal(true);

    const { appId } = useParams()
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    // Saved Push Notification templates - this same compose form doubles as the template
    // editor when opened as apps/:appId/push-notification?mode=template[&template_id=X], reached
    // from the Templates list page (Messages > Push > Templates) or the Automation Push node's
    // "+ Add Template"/"Edit template" links. In that mode there's no audience or delivery
    // schedule (a template has neither) - see isTemplateMode below.
    const isTemplateMode = searchParams.get('mode') === 'template';
    const [templateNameInput, setTemplateNameInput] = useState('');
    const [savingTemplate, setSavingTemplate] = useState(false);
    const [editingTemplateId, setEditingTemplateId] = useState(null);

    // Handle edit mode - populate form with existing message data
    useEffect(() => {
        if (location.state?.editMessage) {
            const editMsg = location.state.editMessage;
            setIsEditMode(true);
            setEditMessageId(editMsg.id);

            // Set basic fields
            setTitle(editMsg.title || '');
            setMessage(editMsg.message || '');
            setMessageName(editMsg.name || '');
            setImageUrl(editMsg.image || '');

            // Set audience type
            setAudienceType(
                findOptionByValue(MESSAGE_AUDIENCE_OPTIONS, editMsg.audience_type)?.value === 2
                    ? 'segment'
                    : 'subscribed'
            );

            // Set segments if available
            if (editMsg.segment_ids) {
                try {
                    const segmentIds = typeof editMsg.segment_ids === 'string'
                        ? JSON.parse(editMsg.segment_ids)
                        : editMsg.segment_ids;
                    setSelectedSegments(segmentIds || []);
                } catch (e) {
                    console.error('Error parsing segment_ids:', e);
                }
            }

            // Set subscriptions if available
            if (editMsg.subscription_ids) {
                try {
                    const subIds = typeof editMsg.subscription_ids === 'string'
                        ? JSON.parse(editMsg.subscription_ids)
                        : editMsg.subscription_ids;
                    setSelectedSubscriptions(subIds || []);
                } catch (e) {
                    console.error('Error parsing subscription_ids:', e);
                }
            }

            // Parse notification_data for additional fields
            if (editMsg.notification_data) {
                try {
                    const notifData = typeof editMsg.notification_data === 'string'
                        ? JSON.parse(editMsg.notification_data)
                        : editMsg.notification_data;

                    if (notifData.largeIcon) setLargeIcon(notifData.largeIcon);
                    if (notifData.smallIcon) setSmallIcon(notifData.smallIcon);
                    if (notifData.sound) setSound(notifData.sound);
                    if (notifData.lockscreenVisibility) setLockscreenVisibility(notifData.lockscreenVisibility);
                    if (notifData.priority) setPriority(notifData.priority);
                    if (notifData.timeToLive) setTimeToLive(notifData.timeToLive);
                    if (notifData.timeUnit) setTimeUnit(notifData.timeUnit);
                    if (notifData.keyValuePairs && notifData.keyValuePairs.length > 0) {
                        setKeyValuePairs(notifData.keyValuePairs);
                        const channelPair = notifData.keyValuePairs.find(p => p.key === 'channelId');
                        if (channelPair && channelPair.value) setSelectedChannelId(channelPair.value);
                    }
                    if (notifData.actionButtons && notifData.actionButtons.length > 0) {
                        setActionButtons(notifData.actionButtons);
                        setActionIndex(notifData.actionButtons.length);
                    }
                    const bestTimeEnabled = Boolean(
                        notifData.use_best_send_time ||
                        notifData.best_time_delivery ||
                        notifData.bestTimeDelivery ||
                        notifData.delivery_mode === 'best_time'
                    );
                    setUseBestSendTime(bestTimeEnabled);
                } catch (e) {
                    console.error('Error parsing notification_data:', e);
                }
            }

            // Set scheduled date/time
            if (editMsg.scheduled_at) {
                setDeliveryType('scheduled');
                const scheduledDateTime = new Date(editMsg.scheduled_at);
                setScheduledDate(toLocalIsoDate(scheduledDateTime));
                setScheduledTime(toLocalIsoTime(scheduledDateTime));
            }

            // Clear the location state to prevent re-populating on refresh
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);


    // Arriving from Engage → Funnel ("Create segment"): start with that segment as the audience.
    useEffect(() => {
        const ids = location.state?.presetSegmentIds;
        if (Array.isArray(ids) && ids.length) {
            setAudienceType('segment');
            setSelectedSegments(ids);
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    const handleAddPair = () => {
        setKeyValuePairs([...keyValuePairs, { key: '', value: '' }]);
    };
    const [searchTerm, setSearchTerm] = useState('');
    const [subscriptions, setSubscriptions] = useState([]); // eslint-disable-line no-unused-vars

    const [selectedSubscriptions, setSelectedSubscriptions] = useState([]);


    const handleCheckboxChange = (subscriptionId) => {

        setSelectedSubscriptions(prevState =>
            prevState.includes(subscriptionId)
                ? prevState.filter(id => id !== subscriptionId)
                : [...prevState, subscriptionId]
        );
    };

    const getAppUser = useCallback(() => {
        const { subscribed } = subscriptionStatusCodes();
        fetchWithAuth(Utils.baseurl + 'get/app/subscriptions', {
            method: 'POST',
            body: JSON.stringify({
                appId,
                isTest: 1,
                status: subscribed,
            }),
        })
            .then((response) => response.json())
            .then(async (result) => {
                if (result.status) {
                    setAppUsers(result.data.appSubscriptionData || []);
                }
            })
            .catch((error) => console.error(error));
    }, [appId]);

    const fetchSegments = useCallback(async () => {
        try {
            const response = await fetchWithAuth(Utils.baseurl + 'get/segments', {
                method: 'POST',
                body: JSON.stringify({ app_id: appId }),
            });
            const result = await response.json();
            if (result.status) {
                setSegments(result.data);
            }
        } catch (error) {
            console.error('Error fetching segments:', error);
        }
    }, [appId]);

    // When Select Segment modal opens, fetch live subscriber counts per segment (runtime)
    const segmentIdsKey = segments.map(s => s.id).join(',');
    useEffect(() => {
        if (!showSegmentModal || !appId || !segments.length) return;
        setSegmentCounts({});
        const filtersList = segments.map(s => {
            try {
                return Array.isArray(s.filters) ? s.filters : (s.filters ? JSON.parse(s.filters) : []);
            } catch {
                return [];
            }
        });
        const countPromises = segments.map((seg, i) =>
            fetchWithAuth(Utils.baseurl + 'count/segment/subscriptions', {
                method: 'POST',
                body: JSON.stringify({ app_id: appId, filters: filtersList[i] }),
            })
                .then(res => res.json())
                .then(data => ({ id: seg.id, count: data.status ? data.count : 0 }))
                .catch(() => ({ id: seg.id, count: 0 }))
        );
        Promise.all(countPromises).then(results => {
            const countsMap = Object.fromEntries(results.map(r => [r.id, r.count]));
            setSegmentCounts(prev => ({ ...prev, ...countsMap }));

            // Batch-save to DB only where runtime count differs from saved value
            const toUpdate = results
                .filter(r => {
                    const seg = segments.find(s => s.id === r.id);
                    return seg && Number(seg.subscription_count) !== r.count;
                })
                .map(r => ({ id: r.id, subscription_count: r.count }));

            if (toUpdate.length > 0) {
                fetchWithAuth(Utils.baseurl + 'update/segment/subscription-counts', {
                    method: 'POST',
                    body: JSON.stringify({ updates: toUpdate }),
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.status) {
                            setSegments(prev =>
                                prev.map(seg => {
                                    const u = toUpdate.find(x => x.id === seg.id);
                                    return u ? { ...seg, subscription_count: u.subscription_count } : seg;
                                })
                            );
                        }
                    })
                    .catch(err => console.error('Update segment counts:', err));
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showSegmentModal, appId, segmentIdsKey]);

    useEffect(() => {
        getAppUser()
        fetchSegments()
        fetchWithAuth(Utils.baseurl + 'getbyid/application', {
            method: 'POST',
            body: JSON.stringify({ id: appId }),
        })
            .then((response) => response.json())
            .then(async (result) => {
                if (result.status) {
                    setAppData(result.data)
                } else {
                    toast.error(result.message)
                }
            })
            .catch((error) => console.error(error));
    }, [appId, getAppUser, fetchSegments]);

    useEffect(() => {
        if (selectedChannelId) return;
        if ((sound || '').trim()) {
            setPriority('High');
        } ;
    }, [selectedChannelId, sound]);


    const handleSendTestPush = async () => {
        if (!ensurePushContent()) return;
        setLoader(true);
        const data = { ...buildFormData(), appId: appId, image: isValidImageUrl ? imageUrl : null };

        if (audienceType === 'segment' && !selectedSegments.length) {
            toast.error('Please select at least one segment');
            setLoader(false);
            return;
        }
        if (audienceType !== 'segment' && !selectedSubscriptions.length) {
            toast.error('Please select at least one test subscriber');
            setLoader(false);
            return;
        }

        if (deliveryType === 'scheduled') {
            if (!data.scheduledAt) {
                toast.error('Please select both date and time for scheduled delivery');
                setLoader(false);
                return;
            }
            try {
                const recipientCount = audienceType === 'segment'
                    ? selectedSegments.length
                    : selectedSubscriptions.length;
                const scheduleRes = await fetchWithAuth(Utils.baseurl + 'create/scheduled-notification', {
                    method: 'POST',
                    body: JSON.stringify({
                        appId: appId,
                        name: `${data.messageName || data.title} (test)`,
                        title: data.title,
                        message: data.message,
                        image: data.image,
                        scheduledAt: data.scheduledAt,
                        audience_type: findOptionByValue(
                            MESSAGE_AUDIENCE_OPTIONS,
                            audienceType === 'segment' ? 2 : 3
                        )?.value,
                        segmentIds: audienceType === 'segment' ? selectedSegments : null,
                        subscriptionIds: audienceType === 'segment' ? null : selectedSubscriptions,
                        notificationData: data,
                    }),
                });
                const result = await scheduleRes.json();
                if (result.status) {
                    toast.success(
                        audienceType === 'segment'
                            ? 'Test notification scheduled for the selected segment(s). It will send at the selected time.'
                            : `Test notification scheduled for ${recipientCount} user(s). It will send at the selected time.`
                    );
                } else {
                    toast.error(result.message || 'Failed to schedule test notification');
                }
            } catch (error) {
                console.error('Error scheduling test notification:', error);
                toast.error('Error scheduling notification');
            }
            setLoader(false);
            return;
        }

        if (audienceType === 'segment') {
            data.segmentIds = selectedSegments;
        } else {
            data.subscriptionIds = selectedSubscriptions;
        }
        data.audience_type = findOptionByValue(
            MESSAGE_AUDIENCE_OPTIONS,
            audienceType === 'segment' ? 2 : 3
        )?.value;

        fetchWithAuth(Utils.baseurl + 'notification/send', {
            method: 'POST',
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.success) {
                    toast.success(result.message);
                } else {
                    toast.error(result.message || 'Failed to send');
                }
                setLoader(false);
            })
            .catch((error) => {
                console.error(error);
                toast.error('Failed to send notification');
                setLoader(false);
            });
    };

    const handleRemovePair = (index) => {
        // if (index === 0) return;
        const updatedPairs = keyValuePairs.filter((_, i) => i !== index);
        setKeyValuePairs(updatedPairs);
    };

    const handleChange = (index, e) => {
        const { name, value } = e.target;
        const updatedPairs = keyValuePairs.map((pair, i) =>
            i === index ? { ...pair, [name]: value } : pair
        );
        setKeyValuePairs(updatedPairs);
    };
    useEffect(() => {
        fetchWithAuth(Utils.baseurl + "users", { method: "GET", redirect: "follow" })
            .then((response) => response.json())
            .then((result) => {
                setSubscriptions(result.data)
            })
            .catch((error) => console.error(error));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (message.length === 0) {
            setdisplayMessage("Default message")
        } else {
            setdisplayMessage(message)
        }
    }, [message]);

    useEffect(() => {
        if (!appId) return;
        fetchWithAuth(Utils.baseurl + 'getall/notification/group', {
            method: 'POST',
            body: JSON.stringify({ id: appId }),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.status && result.data && Array.isArray(result.data)) {
                    const channels = result.data.flatMap((g) =>
                        (g.notificationChannels || []).map((ch) => ({
                            channel_id: ch.channel_id || ch.channelId || '',
                            name: ch.name || '',
                            Importance: ch.Importance !== null && ch.Importance !== undefined ? ch.Importance : 6,
                        })).filter((ch) => ch.channel_id)
                    );
                    setNotificationChannelsList(channels);
                }
            })
            .catch(() => { });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId]);


    const loadTemplateIntoForm = useCallback((tpl) => {
        if (!tpl) return;
        setEditingTemplateId(tpl.id);
        setTemplateNameInput(tpl.name || '');
        setTitle(tpl.title || '');
        setMessage(tpl.message || '');
        setImageUrl(tpl.image || '');
        setIsValidImageUrl(!!tpl.image);
        setLargeIcon(tpl.largeIcon || '');
        setSmallIcon(tpl.smallIcon || '');
        setSound(tpl.sound || '');
        setLockscreenVisibility(tpl.lockscreenVisibility || 'Public');
        setPriority(tpl.priority || 'High');
        setTimeToLive(tpl.timeToLive || 3);
        setTimeUnit(tpl.timeUnit || 'days');
        if (Array.isArray(tpl.keyValuePairs) && tpl.keyValuePairs.length > 0) {
            setKeyValuePairs(tpl.keyValuePairs);
            const channelPair = tpl.keyValuePairs.find((p) => p.key === 'channelId');
            if (channelPair && channelPair.value) setSelectedChannelId(channelPair.value);
        }
        if (Array.isArray(tpl.actionButtons) && tpl.actionButtons.length > 0) {
            setActionButtons(tpl.actionButtons);
            setActionIndex(tpl.actionButtons.length);
        }
    }, []);

    // Template editor mode: ?template_id=X means edit an existing one, otherwise this is a
    // blank "New Template" form.
    useEffect(() => {
        if (!isTemplateMode) return;
        const templateId = searchParams.get('template_id');
        if (!templateId || !appId) return;
        fetchWithAuth(Utils.baseurl + 'application/push/templates/get', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ app_id: appId, id: templateId }),
        })
            .then((res) => res.json())
            .then((result) => { if (result.status) loadTemplateIntoForm(result.data); })
            .catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, isTemplateMode]);

    const handleSaveTemplate = async () => {
        const name = templateNameInput.trim();
        if (!name) { toast.error('Please enter a template name'); return; }
        if (!(title || '').trim() || !(message || '').trim()) {
            toast.error('Title and Message are required to save a template');
            return;
        }
        setSavingTemplate(true);
        try {
            const res = await fetchWithAuth(Utils.baseurl + 'application/push/templates/save', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    app_id: appId,
                    id: editingTemplateId || undefined,
                    name,
                    ...buildFormData(),
                    // buildFormData() sends the local `image` blob-preview state, which is a
                    // transient blob: URL valid only for this tab/session - never something
                    // worth persisting. Templates must store the uploaded/typed imageUrl instead,
                    // same convention as the regular compose-and-send submit handlers above.
                    image: isValidImageUrl ? imageUrl : null,
                }),
            });
            const result = await res.json();
            if (result.status) {
                toast.success(result.message || 'Template saved');
                const newId = result.data?.id || editingTemplateId;
                setEditingTemplateId(newId);
                if (newId) {
                    const next = new URLSearchParams(searchParams);
                    next.set('template_id', newId);
                    setSearchParams(next, { replace: true });
                }
            } else {
                toast.error(result.message || 'Failed to save template');
            }
        } catch (e) {
            toast.error('Failed to save template');
        } finally {
            setSavingTemplate(false);
        }
    };

    const buildFormData = () => {
        const pairs = selectedChannelId
            ? [...keyValuePairs.filter(p => p.key !== 'channelId'), { key: 'channelId', value: selectedChannelId }]
            : keyValuePairs;
        return {
            title,
            message,
            image,
            largeIcon,
            smallIcon,
            sound,
            lockscreenVisibility,
            priority,
            timeToLive,
            timeUnit,
            keyValuePairs: pairs,
            actionButtons,
            deliveryType,
            scheduledAt: deliveryType !== 'scheduled'
                ? null
                : combineLocalDateTime(scheduledDate, scheduledTime)?.toISOString() || null,
            messageName: messageName || title,
            use_best_send_time: deliveryType === 'scheduled' ? Boolean(useBestSendTime) : false
        };
    };

    const clearFieldError = (key) => {
        setFieldErrors((prev) => (prev[key] ? { ...prev, [key]: '' } : prev));
    };

    const ensurePushContent = () => {
        const next = {};
        if (!(title || '').trim()) next.title = 'Title is required';
        if (!(message || '').trim()) next.message = 'Message is required';
        if (deliveryType === 'scheduled') {
            if (!scheduledDate) next.scheduledDate = 'Date is required';
            if (!scheduledTime) next.scheduledTime = 'Time is required';
        }
        setFieldErrors(next);
        if (Object.keys(next).length) {
            toast.error('Please fill all required fields');
            return false;
        }
        return true;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!ensurePushContent()) return;
        setFormData(buildFormData());
        setModalMode(deliveryType === 'scheduled' ? 'schedule' : 'test');
        setShowModal(true);
    };

    const handleOpenTestModal = (e) => {
        e.preventDefault();
        setFormData(buildFormData());
        setModalMode('test');
        setShowModal(true);
    };

    const handleSendToAllSubscribed = async (e) => {
        e.preventDefault();
        if (!ensurePushContent()) return;
        const { isConfirmed } = await Swal.fire({
            title: 'Send to all subscribers?',
            text: 'This notification will be sent to all subscribed users. This action cannot be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, send',
            cancelButtonText: 'Cancel',
        });
        if (!isConfirmed) return;
        setSendingToAll(true);
        const baseForm = buildFormData();
        const data = { ...baseForm, appId, image: isValidImageUrl ? imageUrl : null };
        try {
            if (deliveryType === 'immediately') {
                try {
                    const sendRes = await fetchWithAuth(Utils.baseurl + 'notification/send', {
                        method: 'POST',
                        body: JSON.stringify({
                            ...data,
                            sendToAll: true,
                            audience_type: findOptionByValue(MESSAGE_AUDIENCE_OPTIONS, 1)?.value,
                        }),
                    });
                    const sendResult = await sendRes.json();
                    if (sendResult.success) {
                        toast.success(
                            sendResult.message || 'Notification sent successfully.'
                        );
                    } else {
                        toast.error(
                            sendResult.message || 'Failed to send notification'
                        );
                    }
                } catch (sendErr) {
                    console.error(sendErr);
                    toast.error('Failed to send notification');
                }
                setSendingToAll(false);
                return;
            }

            const scheduledData = {
                appId,
                name: baseForm.messageName || baseForm.title,
                title: baseForm.title,
                message: baseForm.message,
                image: isValidImageUrl ? imageUrl : null,
                scheduledAt: baseForm.scheduledAt,
                audience_type: findOptionByValue(MESSAGE_AUDIENCE_OPTIONS, 1)?.value,
                segmentIds: null,
                subscriptionIds: null,
                notificationData: baseForm
            };
            const endpoint = isEditMode ? 'update/scheduled-notification' : 'create/scheduled-notification';
            if (isEditMode) {
                scheduledData.id = editMessageId;
            }
            const scheduleRes = await fetchWithAuth(Utils.baseurl + endpoint, {
                method: 'POST',
                body: JSON.stringify(scheduledData),
            });
            const scheduleResult = await scheduleRes.json();
            if (scheduleResult.status) {
                toast.success(isEditMode ? 'Notification updated successfully!' : 'Notification scheduled successfully for all subscribed users!');
            } else {
                toast.error(scheduleResult.message || 'Failed to schedule notification');
            }
        } catch (err) {
            console.error(err);
            toast.error(deliveryType === 'scheduled' ? 'Failed to schedule notification' : 'Failed to send notification');
        }
        setSendingToAll(false);
    };

    const handleScheduleNotification = async () => {
        setLoader(true);
        let data = formData;

        const scheduledData = {
            appId,
            name: data.messageName || data.title,
            title: data.title,
            message: data.message,
            image: isValidImageUrl ? imageUrl : null,
            scheduledAt: data.scheduledAt,
            audience_type: findOptionByValue(
                MESSAGE_AUDIENCE_OPTIONS,
                audienceType === 'segment' ? 2 : 1
            )?.value,
            segmentIds: audienceType === 'segment' ? selectedSegments : null,
            subscriptionIds: null,
            notificationData: data
        };

        try {
            // Use update endpoint if in edit mode, otherwise create
            const endpoint = isEditMode
                ? 'update/scheduled-notification'
                : 'create/scheduled-notification';

            if (isEditMode) {
                scheduledData.id = editMessageId;
            }

            const response = await fetchWithAuth(Utils.baseurl + endpoint, {
                method: 'POST',
                body: JSON.stringify(scheduledData),
            });
            const result = await response.json();

            if (result.status) {
                toast.success(isEditMode ? 'Notification updated successfully!' : 'Notification scheduled successfully!');
                handleClose();
                // Reset form
                setTitle('');
                setMessage('');
                setImageUrl('');
                setScheduledDate('');
                setScheduledTime('');
                setMessageName('');
                setUseBestSendTime(false);
                setSelectedSegments([]);
                setSelectedSubscriptions([]);
                setIsEditMode(false);
                setEditMessageId(null);
            } else {
                toast.error(result.message || 'Failed to schedule notification');
            }
        } catch (error) {
            console.error('Error scheduling notification:', error);
            toast.error('Error scheduling notification');
        }
        setLoader(false);
    };

    useEffect(() => {
        const imageUrlRegex = /\.(jpeg|jpg|png|webp)$/i;
        setIsValidImageUrl(imageUrlRegex.test(imageUrl));
    }, [imageUrl]);

    const deleteUploadedImageIfNeeded = async (pathToDelete) => {
        const p = pathToDelete || uploadedImagePath;
        if (!p) return;
        try {
            await fetchWithAuth(Utils.baseurl + 'delete/notification-image', {
                method: 'POST',
                body: JSON.stringify({ path: p }),
            });
        } catch (err) {
            // Best-effort cleanup; don't block UX on failure
            console.error('Failed to delete uploaded image:', err);
        }
    };

    const clearImage = async ({ deleteUploaded = false } = {}) => {
        if (deleteUploaded) {
            await deleteUploadedImageIfNeeded();
        }
        if (image) {
            try { URL.revokeObjectURL(image); } catch { }
        }
        setImage(null);
        setImageUrl('');
        setIsValidImageUrl(false);
        setUploadedImagePath('');
        setImageUrlLoadError(false);
        if (imageFileInputRef.current) {
            imageFileInputRef.current.value = '';
        }
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        // Remove any manually-entered URL and previous selection
        await clearImage({ deleteUploaded: true });

        // Show local preview immediately
        const previewUrl = URL.createObjectURL(file);
        setImage(previewUrl);

        try {
            setIsImageUploading(true);
            const fd = new FormData();
            fd.append('image', file);

            const response = await fetchWithAuth(Utils.baseurl + 'upload/notification-image', {
                method: 'POST',
                headers: {
                    ...authHeaders(Utils.storageKeys.token),
                    ...(typeof Utils.getBackendBaseUrl === 'function' ? { 'X-Public-Base-Url': Utils.getBackendBaseUrl() } : {}),
                },
                body: fd,
            });
            const result = await response.json();
            if (!result.status || !result.path) {
                throw new Error(result.message || 'Upload failed');
            }

            // Use backend's url (no double slash); fallback to base + path if missing
            const finalUrl = String(Utils.baseurl || '').replace(/\/+$/, '') + '/' + String(result.path || '').replace(/^\/+/, '');
            setImageUrlLoadError(false);
            setImageUrl(finalUrl);
            setUploadedImagePath(result.path || '');
        } catch (err) {
            console.error(err);
            toast.error('Image upload failed');
            await clearImage({ deleteUploaded: true });
        } finally {
            setIsImageUploading(false);
        }
    };

    const handleRemoveButton = (index) => {
        const updatedButtons = actionButtons.filter((_, i) => i !== index);
        setActionIndex(updatedButtons.length)
        setActionButtons(updatedButtons);
    };
    const handleChangeAction = (index, e) => {

        const { name, value, type, checked } = e.target;

        const updatedButtons = actionButtons.map((button, i) =>
            i === index ? { ...button, [name]: type === 'checkbox' ? checked : value } : button
        );
        setActionButtons(updatedButtons);
    };

    const handleAddButton = () => {
        setActionIndex(actionButtons.length + 1)
        setActionButtons([...actionButtons, { id: '', label: '', iconPath: '', isSystemIcon: false }]);
    };


    return (
        <div >
            <div>

                <h3>Push Notification</h3>
            </div>
            <Card className='flex-row flex-wrap'>
                <div className="my-4 mx-4 col-md-6 col-sm-12 col-xs-12">
                    <Form onSubmit={handleSubmit} >
                        <div>
                            {/* Template editor mode (apps/:appId/push-notification?mode=template[&template_id=X]) -
                                reached from the Templates list page or the Automation Push node's "+ Add
                                Template"/"Edit template" links. A template has no audience or delivery
                                schedule, so this card replaces those with just a name field; the normal
                                compose flow below (Audience, Delivery Schedule, Review and Send) is
                                untouched when this mode isn't active. */}
                            {isTemplateMode && (
                                <Card className="mb-3">
                                    <Card.Header style={{ backgroundColor: "#e5e8eb" }}>
                                        {editingTemplateId ? 'Edit Template' : 'New Template'}
                                    </Card.Header>
                                    <Card.Body>
                                        <Form.Label>Template name</Form.Label>
                                        <div className="d-flex gap-2 align-items-start flex-wrap">
                                            <Form.Control
                                                type="text"
                                                placeholder="e.g. Weekly Digest"
                                                style={{ maxWidth: 360 }}
                                                value={templateNameInput}
                                                onChange={(e) => setTemplateNameInput(e.target.value)}
                                            />
                                        </div>
                                    </Card.Body>
                                </Card>
                            )}

                            {/* Audience Section */}
                            {!isTemplateMode && (
                            <Card className="mb-3">
                                <Card.Header style={{ backgroundColor: "#e5e8eb" }}>1. Audience</Card.Header>
                                <Card.Body>
                                    <Form.Group>
                                        <Form.Check
                                            type="radio"
                                            label="Send to Subscribed Users"
                                            name="audienceType"
                                            id="audienceSubscribed"
                                            checked={audienceType === 'subscribed'}
                                            onChange={() => setAudienceType('subscribed')}
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Send to particular segment(s)"
                                            name="audienceType"
                                            id="audienceSegment"
                                            checked={audienceType === 'segment'}
                                            onChange={() => setAudienceType('segment')}
                                            className="mt-2"
                                        />
                                    </Form.Group>

                                    {audienceType === 'segment' && (
                                        <div className="mt-3">
                                            <p className="mb-2">What segment(s) should receive this message?</p>
                                            {selectedSegments.length > 0 && (
                                                <div className="mb-3 p-2" style={{ backgroundColor: '#e7f3ff', borderRadius: '4px' }}>
                                                    <small className="text-muted">
                                                        <strong>Total Subscribers: </strong>
                                                        {selectedSegments.reduce((total, segmentId) => {
                                                            const segment = segments.find(s => s.id === segmentId);
                                                            return total + (segment?.subscription_count || 0);
                                                        }, 0).toLocaleString()}
                                                    </small>
                                                </div>
                                            )}
                                            <div className="d-flex flex-wrap gap-2 mb-2">
                                                {selectedSegments.map(segmentId => {
                                                    const segment = segments.find(s => s.id === segmentId);
                                                    return segment ? (
                                                        <div key={segmentId} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '14px', padding: '8px 12px' }}>
                                                            <span>{segment.name} ({segment.subscription_count || 0})</span>
                                                            <button
                                                                type="button"
                                                                className="btn-close btn-close-white ms-2"
                                                                style={{ fontSize: '10px' }}
                                                                onClick={() => setSelectedSegments(prev => prev.filter(id => id !== segmentId))}
                                                            ></button>
                                                        </div>
                                                    ) : null;
                                                })}
                                            </div>
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() => setShowSegmentModal(true)}
                                            >
                                                <HiPlusCircle /> Include Segment
                                            </Button>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                            )}

                            <Form.Group controlId="formTitle">
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter title"
                                    value={title}
                                    isInvalid={Boolean(fieldErrors.title)}
                                    onChange={(e) => {
                                        setTitle(e.target.value);
                                        clearFieldError('title');
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{fieldErrors.title}</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="formMessage">
                                <Form.Label>Message</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Enter message"
                                    value={message}
                                    isInvalid={Boolean(fieldErrors.message)}
                                    onChange={(e) => {
                                        setMessage(e.target.value);
                                        clearFieldError('message');
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{fieldErrors.message}</Form.Control.Feedback>
                            </Form.Group>

                            {/* <Form.Group controlId="formImage">
                                <Form.Label>Image</Form.Label>
                                <Form.Control
                                    type="file"
                                    onChange={(e) => setImage(URL.createObjectURL(e.target.files[0]))}
                                />
                            </Form.Group> */}


                            <Form.Group controlId="formImage">
                                <Form.Label>Image</Form.Label>
                                <InputGroup className="flex-nowrap align-items-stretch">
                                    <Form.Control
                                        type="text"
                                        placeholder="Upload or input URL"
                                        value={imageUrl}
                                        onChange={async (e) => {
                                            setImageUrlLoadError(false);
                                            // If user starts typing/pasting a URL, clear any selected/uploaded image
                                            if (image || uploadedImagePath) {
                                                await clearImage({ deleteUploaded: true });
                                            }
                                            return setImageUrl(e.target.value);
                                        }}
                                    />
                                    <input
                                        type="file"
                                        id="upload"
                                        accept="image/jpeg,image/jpg,image/png,image/webp"
                                        ref={imageFileInputRef}
                                        onChange={handleImageUpload}
                                        style={{ display: 'none' }}
                                    />
                                    <Button
                                        as="label"
                                        htmlFor="upload"
                                        variant="outline-secondary"
                                        className={`mb-0${isImageUploading ? ' disabled' : ''}`}
                                        style={{ cursor: isImageUploading ? 'not-allowed' : 'pointer' }}
                                    >
                                        {isImageUploading ? 'Uploading...' : 'Upload'}
                                    </Button>
                                    {(imageUrl || image) && (
                                        <Button
                                            variant="outline-danger"
                                            className="mb-0"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                clearImage({ deleteUploaded: true });
                                            }}
                                        >
                                            Remove
                                        </Button>
                                    )}
                                </InputGroup>
                                <Form.Text className="text-muted">JPEG, PNG or WebP only. GIF and SVG are not supported for notifications.</Form.Text>
                            </Form.Group>
                            <Form.Group controlId="largeIcon">
                                <Form.Label>Large Icon</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Input Resource Name"
                                    value={largeIcon}
                                    onChange={(e) => setLargeIcon(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group controlId="smallIcon">
                                <Form.Label>Small Icon</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Input Resource Name"
                                    value={smallIcon}
                                    onChange={(e) => setSmallIcon(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group controlId="formNotificationChannel">
                                <Form.Label>
                                    Notification Channel
                                    <HelpTooltip text="Optional. For Android background sound, select a channel created under Setting → Notification Channel." />
                                </Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedChannelId}
                                    onChange={(e) => setSelectedChannelId(e.target.value)}
                                >
                                    <option value="">Default (no channel)</option>
                                    {notificationChannelsList.map((ch) => (
                                        <option key={ch.channel_id} value={ch.channel_id}>
                                            {ch.name || ch.channel_id}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                            {!selectedChannelId && (
                                <Form.Group controlId="formSound">
                                    <Form.Label>Sound</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Default is device's default"
                                        value={sound}
                                        onChange={(e) => setSound(e.target.value)}
                                    />
                                </Form.Group>
                            )}

                            <Form.Group controlId="Lockscreen">
                                <Form.Label>Lockscreen Visibility</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={lockscreenVisibility}
                                    onChange={(e) => setLockscreenVisibility(e.target.value)}
                                >
                                    <option>Public</option>
                                    <option>Private</option>
                                    <option>Secret</option>
                                </Form.Control>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="4">
                                    Priority
                                    <HelpTooltip text={<>Keep this <strong>High</strong> if you want accurate delivery/confirm/click data. When the app is closed or killed on the device, a Normal-priority push may not wake it up to fire the delivery, confirm, and other tracking API calls — so that data comes in incomplete or wrong. High priority wakes the app in the background to make those calls even when it isn't running.</>} />
                                </Form.Label>
                                <Col sm="10">
                                    {selectedChannelId ? (
                                        <span className="text-muted">
                                            {(() => {
                                                const ch = notificationChannelsList.find((c) => c.channel_id === selectedChannelId);
                                                const imp = ch && ch.Importance !== null && ch.Importance !== undefined ? ch.Importance : 6;
                                                const label = imp === 2 ? 'Low' : imp === 4 ? 'Medium' : imp === 6 ? 'High' : 'Urgent';
                                                return <>From channel: <strong>{label}</strong></>;
                                            })()}
                                        </span>
                                    ) : (
                                        <>
                                            <Form.Check
                                                type="radio"
                                                label="High"
                                                name="priority"
                                                id="priorityHigh"
                                                checked={priority === 'High'}
                                                onChange={() => setPriority('High')}
                                                inline
                                            />
                                            <Form.Check
                                                type="radio"
                                                label="Normal"
                                                name="priority"
                                                id="priorityNormal"
                                                checked={priority === 'Normal'}
                                                onChange={() => setPriority('Normal')}
                                                inline
                                            />
                                        </>
                                    )}
                                </Col>
                            </Form.Group>

                            {/* Time To Live Section */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label>
                                    Time To Live <i className="bi bi-question-circle-fill"></i>
                                </Form.Label>
                                <Col sm="8" className="d-flex">
                                    <Form.Control
                                        type="number"
                                        value={timeToLive}
                                        onChange={(e) => setTimeToLive(e.target.value)}
                                        min={1}
                                    />
                                    &nbsp;
                                    <Form.Control
                                        as="select"
                                        value={timeUnit}
                                        onChange={(e) => setTimeUnit(e.target.value)}
                                    >
                                        <option value="minutes">minutes</option>
                                        <option value="hours">hours</option>
                                        <option value="days">days</option>
                                        <option value="weeks">weeks</option>
                                    </Form.Control>
                                </Col>
                            </Form.Group>

                            <div >
                                <Card>
                                    <Card.Header style={{ backgroundColor: "#e5e8eb" }}>Additional Data</Card.Header>
                                    <Card.Body>
                                        {keyValuePairs.map((pair, index) => (
                                            <Row key={index} >
                                                <Form.Label>Field {index + 1}</Form.Label>
                                                <Col md={5}>
                                                    <Form.Group controlId={`key-${index}`}>
                                                        <Form.Control
                                                            type="text"
                                                            name="key"
                                                            value={pair.key}
                                                            onChange={(e) => handleChange(index, e)}
                                                            placeholder="Input Key"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={7} className='d-flex'>
                                                    <Form.Group controlId={`value-${index}`}>
                                                        {/* <Form.Label>Value</Form.Label> */}
                                                        <Form.Control
                                                            type="text"
                                                            name="value"
                                                            value={pair.value}
                                                            onChange={(e) => handleChange(index, e)}
                                                            placeholder="Input Value"
                                                        />
                                                    </Form.Group>
                                                    <div>

                                                        <Button style={{ backgroundColor: "white", color: "gray", border: "0", fontSize: "20px", marginTop: "-8%" }} onClick={() => handleRemovePair(index)}>
                                                            <RxCross1 />
                                                        </Button>
                                                    </div>
                                                </Col>
                                                {/* <Col md={2} >
                                                </Col> */}
                                            </Row>
                                        ))}
                                        <Button onClick={handleAddPair} style={{ backgroundColor: "white", color: "black", border: "0" }}>
                                            <HiPlusCircle /> Add Fields
                                        </Button>

                                    </Card.Body>
                                </Card>
                            </div>
                            <div style={{ marginTop: "5%" }}>
                                <Card>
                                    <Card.Header style={{ backgroundColor: "#e5e8eb" }}>Android Action Buttons</Card.Header>
                                    <Card.Body>
                                        {actionButtons.map((button, index) => (
                                            <Row key={index}>
                                                <Col md={5}>
                                                    <Form.Group controlId={`id-${index}`}>
                                                        <Form.Label>Action ID {index + 1}</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="id"
                                                            value={button.id}
                                                            onChange={(e) => handleChangeAction(index, e)}
                                                            placeholder="e.g. accept-button"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md={5}>
                                                    <Form.Group controlId={`label-${index}`}>
                                                        <Form.Label>Button Label {index + 1}</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="label"
                                                            value={button.label}
                                                            onChange={(e) => handleChangeAction(index, e)}
                                                            placeholder="e.g. Accept"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md={2}>
                                                    <Button
                                                        style={{
                                                            backgroundColor: "white",
                                                            color: "gray",
                                                            border: "0",
                                                            fontSize: "20px",
                                                            marginTop: "25px",
                                                        }}
                                                        onClick={() => handleRemoveButton(index)}
                                                    >
                                                        <RxCross1 />
                                                    </Button>
                                                </Col>

                                                <Col md={5}>
                                                    <Form.Group controlId={`iconPath-${index}`}>
                                                        <Form.Label>Action Icon Path {index + 1}</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="iconPath"
                                                            value={button.iconPath}
                                                            onChange={(e) => handleChangeAction(index, e)}
                                                            placeholder="e.g. hand.thumbsup"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md={5} style={{ marginTop: "5%" }}>
                                                    <Form.Group controlId={`isSystemIcon-${index}`}>
                                                        <Form.Check
                                                            type="checkbox"
                                                            name="isSystemIcon"
                                                            checked={button.isSystemIcon}
                                                            onChange={(e) => handleChangeAction(index, e)}
                                                            label="System Icon"
                                                            style={{ marginTop: "5%" }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        ))}
                                        <Button
                                            onClick={handleAddButton}
                                            className={actionIndex === 3 ? "disabled" : ""}
                                            style={{ backgroundColor: "white", color: "black", border: "0" }}
                                        >
                                            <HiPlusCircle /> Add Button
                                        </Button>
                                    </Card.Body>
                                </Card>

                            </div>

                            {/* Delivery Schedule Section */}
                            {!isTemplateMode && (
                            <div style={{ marginTop: "5%" }}>
                                <Card>
                                    <Card.Header style={{ backgroundColor: "#e5e8eb" }}>3. Delivery Schedule</Card.Header>
                                    <Card.Body>
                                        <Form.Group className="mb-3">
                                            <Form.Label>When should this message start sending?</Form.Label>
                                            <Form.Check
                                                type="radio"
                                                label="Immediately"
                                                name="deliveryType"
                                                id="deliveryImmediate"
                                                checked={deliveryType === 'immediately'}
                                                onChange={() => {
                                                    setDeliveryType('immediately');
                                                    setFieldErrors((prev) => ({ ...prev, scheduledDate: '', scheduledTime: '' }));
                                                }}
                                            />
                                            <Form.Check
                                                type="radio"
                                                label="Specific Time"
                                                name="deliveryType"
                                                id="deliveryScheduled"
                                                checked={deliveryType === 'scheduled'}
                                                onChange={() => setDeliveryType('scheduled')}
                                                className="mt-2"
                                            />
                                        </Form.Group>

                                        {deliveryType === 'scheduled' && (
                                            <div className="mt-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Message Name (optional)</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter a name for this scheduled message"
                                                        value={messageName}
                                                        onChange={(e) => setMessageName(e.target.value)}
                                                    />
                                                </Form.Group>
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <DateTimePicker
                                                                date={scheduledDate}
                                                                time={scheduledTime}
                                                                minDate={parseLocalIsoDate(toLocalIsoDate())}
                                                                isInvalid={Boolean(fieldErrors.scheduledDate || fieldErrors.scheduledTime)}
                                                                error={fieldErrors.scheduledDate || fieldErrors.scheduledTime}
                                                                onChange={({ date: nextDate, time: nextTime }) => {
                                                                    setScheduledDate(nextDate);
                                                                    setScheduledTime(nextTime);
                                                                    clearFieldError('scheduledDate');
                                                                    clearFieldError('scheduledTime');
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Form.Group className="mb-3">
                                                    <Form.Check
                                                        type="switch"
                                                        id="useBestSendTime"
                                                        label="Send at each user's best active time"
                                                        checked={useBestSendTime}
                                                        onChange={(e) => setUseBestSendTime(e.target.checked)}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Users with a known local best-activity hour are sent in that hour. Users without that hour or timezone are sent at the date and time above.
                                                    </Form.Text>
                                                </Form.Group>
                                                {scheduledDate && scheduledTime ? (
                                                    <div className="alert alert-info mb-0">
                                                        <small>
                                                            <strong style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><FiCalendar size={16} /> Message will be sent: </strong>
                                                            {(() => {
                                                                const dt = combineLocalDateTime(scheduledDate, scheduledTime);
                                                                if (!dt) return '';
                                                                const w = dt.toLocaleDateString(undefined, { weekday: 'long' });
                                                                const when = `${w}, ${formatDateTime(dt)}`;
                                                                return useBestSendTime
                                                                    ? `${when}. Per-user best hour when known; otherwise this time.`
                                                                    : when;
                                                            })()}
                                                        </small>
                                                    </div>
                                                ) : null}
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>
                            </div>
                            )}
                        </div>
                        <div className="mt-3 d-flex gap-2 flex-wrap">
                            {isTemplateMode ? (
                                can("push.manage") ? (
                                    <>
                                        <button type="button" className="add_app_btn_secondary btn_theme_secondary" onClick={handleOpenTestModal}>
                                            <span>Test</span>
                                        </button>
                                        <button type="button" className="add_app_btn btn_theme_primary" onClick={handleSaveTemplate} disabled={savingTemplate}>
                                            <span>{savingTemplate ? 'Saving...' : (editingTemplateId ? 'Update Template' : 'Save Template')}</span>
                                        </button>
                                    </>
                                ) : null
                            ) : (can("push.manage") ? (
                            audienceType === 'subscribed' ? (
                                <>
                                    <Button variant="outline-dark" type="button" onClick={handleOpenTestModal}>
                                        Test and Preview
                                    </Button>
                                    <Button
                                        variant="dark"
                                        type="button"
                                        onClick={handleSendToAllSubscribed}
                                        disabled={sendingToAll}
                                    >
                                        {sendingToAll ? (
                                            <>
                                                <Spinner as="span" animation="border" size="sm" className="me-2" />
                                                {deliveryType === 'scheduled' ? 'Scheduling...' : 'Sending...'}
                                            </>
                                        ) : (
                                            deliveryType === 'scheduled' ? 'Review and Schedule' : 'Review and Send'
                                        )}
                                    </Button>
                                </>
                            ) : (
                                <Button variant="dark" type="submit">
                                    {deliveryType === 'scheduled' ? 'Review and Schedule' : 'Review and Send'}
                                </Button>
                            )
                            ) : null)}
                        </div>
                    </Form>
                    <Modal show={showModal} onHide={handleClose} className='modal-lg' style={{ maxWidth: '100%', marginTop: "50px" }} >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {modalMode === 'schedule'
                                    ? 'Review and Schedule'
                                    : (audienceType === 'segment'
                                        ? 'Review and Send to Segments'
                                        : (deliveryType === 'scheduled' ? 'Schedule Test Push' : 'Send Test Push'))}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {/* Show scheduling info if scheduled */}
                            {deliveryType === 'scheduled' && (
                                <div className="alert alert-primary mb-3">
                                    <strong style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><FiCalendar size={16} /> Scheduled for: </strong>
                                    {(() => {
                                            const dt = new Date(formData?.scheduledAt);
                                            if (Number.isNaN(dt.getTime())) return '';
                                            const w = dt.toLocaleDateString(undefined, { weekday: 'long' });
                                            const when = `${w}, ${formatDateTime(dt)}`;
                                            return useBestSendTime || formData?.use_best_send_time
                                                ? `${when} (best active hour per user when known)`
                                                : when;
                                        })()}
                                    {modalMode === 'test' && audienceType !== 'segment' ? (
                                        <div className="mt-1 small">Only the selected test users will receive it at this time.</div>
                                    ) : null}
                                </div>
                            )}

                            {audienceType === 'segment' ? (
                                <div>
                                    <h5 className="mb-3">Selected Segments:</h5>
                                    {selectedSegments.length === 0 ? (
                                        <p className="text-muted">No segments selected. Please select at least one segment.</p>
                                    ) : (
                                        <div>
                                            {selectedSegments.map(segmentId => {
                                                const segment = segments.find(s => s.id === segmentId);
                                                return segment ? (
                                                    <div key={segmentId} className="alert alert-info d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <strong>{segment.name}</strong>
                                                            <div className="text-muted" style={{ fontSize: '14px' }}>
                                                                {segment.subscription_count?.toLocaleString() || 0} subscribers
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                            <div className="alert alert-warning mt-3">
                                                <strong>Total Recipients:</strong> Notification will be sent to all subscribers in the selected segment(s).
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search by name"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="mb-3"
                                    />
                                    <Table striped bordered hover className='text-center' >
                                        <thead>
                                            <tr>
                                                <th>Select</th>
                                                <th>Name</th>
                                                <th>Mobile</th>
                                                <th>Subscription ID</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {appUsers.length && appUsers.map((sub, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={selectedSubscriptions.includes(sub.subscription_id)}
                                                            onChange={() => handleCheckboxChange(sub.subscription_id)}
                                                        />
                                                    </td>
                                                    <td>{sub.name}</td>
                                                    <td>{sub.mobile}</td>
                                                    <td>{sub.subscription_id}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button style={{ backgroundColor: "white", border: "0", color: "blue" }} onClick={handleClose}>
                                Cancel
                            </Button>
                            {can("push.manage") ? (
                            <Button
                                variant={modalMode === 'schedule' || deliveryType === 'scheduled' ? 'primary' : 'secondary'}
                                onClick={modalMode === 'schedule' ? handleScheduleNotification : handleSendTestPush}
                                disabled={
                                    loader ||
                                    (audienceType === 'segment'
                                        ? selectedSegments.length === 0
                                        : (modalMode !== 'schedule' && selectedSubscriptions.length === 0))
                                }
                            >
                                {loader ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-2"
                                        />
                                        {modalMode === 'schedule' || deliveryType === 'scheduled' ? 'Scheduling...' : 'Sending...'}
                                    </>
                                ) : (
                                    modalMode === 'schedule'
                                        ? 'Schedule Notification'
                                        : (audienceType === 'segment'
                                            ? 'Send to Segments'
                                            : (deliveryType === 'scheduled' ? 'Schedule Test Push' : 'Send Test Push'))
                                )}
                            </Button>
                            ) : null}
                        </Modal.Footer>
                    </Modal>


                    {/* Segment Selection Modal */}
                    <Modal show={showSegmentModal} onHide={() => setShowSegmentModal(false)} className='modal-lg' style={{ maxWidth: '100%', marginTop: "50px" }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Select Segment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Control
                                type="text"
                                placeholder="Search by name"
                                value={segmentSearchTerm}
                                onChange={(e) => setSegmentSearchTerm(e.target.value)}
                                className="mb-3"
                            />
                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                {segments
                                    .filter(segment =>
                                        segment.name.toLowerCase().includes(segmentSearchTerm.toLowerCase())
                                    )
                                    .map((segment) => (
                                        <div
                                            key={segment.id}
                                            className="d-flex align-items-center justify-content-between p-3 mb-2"
                                            style={{
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '8px',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                if (!selectedSegments.includes(segment.id)) {
                                                    setSelectedSegments(prev => [...prev, segment.id]);
                                                }
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <FiBarChart2 size={22} style={{ marginRight: '12px', flexShrink: 0, color: '#6c757d' }} />
                                                <div>
                                                    <div style={{ fontWeight: '500' }}>{segment.name}</div>
                                                    <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                                        {segmentCounts[segment.id] !== undefined
                                                            ? Number(segmentCounts[segment.id]).toLocaleString()
                                                            : '...'} subscribers
                                                    </div>
                                                </div>
                                            </div>
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                disabled={selectedSegments.includes(segment.id)}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (!selectedSegments.includes(segment.id)) {
                                                        setSelectedSegments(prev => [...prev, segment.id]);
                                                    }
                                                }}
                                            >
                                                {selectedSegments.includes(segment.id) ? (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                                        <FiCheck />
                                                        Added
                                                    </span>
                                                ) : (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                                        <FiPlus />
                                                        Add
                                                    </span>
                                                )}
                                            </Button>
                                        </div>
                                    ))}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowSegmentModal(false)}>
                                Done
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div className='position-relative col-xs-12 col-sm-12 col-md-5'>
                    <div className="my-4 mx-4" style={{ position: "sticky", paddingTop: "1rem", top: "0px" }}>
                        <PushNotificationPreview
                            appName={appData.application_name}
                            title={title}
                            message={message}
                            imageUrl={(isValidImageUrl && !imageUrlLoadError) ? imageUrl : (image || null)}
                            showImage={(isValidImageUrl && !imageUrlLoadError) || Boolean(image)}
                            onImageError={() => setImageUrlLoadError(true)}
                            actionButtons={actionButtons}
                        />
                    </div>
                </div>
                {/* <div className='position-relative'>

                    <div className="my-4 mx-4 offset-md-3 scrollable-form " style={{ position: "sticky", paddingTop: "1rem", top: "0px" }}>
                        <div className='mobile-image d-block'>

                        </div>
                    </div>
                </div> */}

            </Card>
        </div>

    );
};

export default PushNotification;







// import React, { useState } from 'react';
// import { Button } from 'react-bootstrap';
// import TestPushModal from './TestPushModal';

// const App = () => {
//     const [showModal, setShowModal] = useState(false);

//     const handleClose = () => setShowModal(false);
//     const handleShow = () => setShowModal(true);

//     return (
//         <div className="p-4">
//             <Button variant="primary" onClick={handleShow}>
//                 Open Test Push Modal
//             </Button>
//             <TestPushModal show={showModal} handleClose={handleClose} />
//         </div>
//     );
// };

// export default App;